import React from 'react';
import './Navi.css';
import logo from '../logo.svg';

export default function Navi() {
  return (
    <div className="nav-container">
      <a><img src={logo} className="nav-logo" alt="logo" /></a>
      <nav className="navi-nav">
        <ul>
          <li><a href="#marshley">Order</a></li>
          <li><a href="#foryou">Menu</a></li>
          <li><a href="#testimonials">Nutrition</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#ready">Servers</a></li>
          <li><a href="#register">Register</a></li>
        </ul>
      </nav>
      <button className="login-btn">Login</button>
    </div>
  );
}
